var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBtc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_403_1315)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5211 19.8705C29.384 28.4421 20.7014 33.6585 12.1279 31.521C3.55805 29.3841 -1.65899 20.702 0.479108 12.1312C2.61532 3.55877 11.2979 -1.65808 19.8687 0.478836C28.4416 2.61575 33.6583 11.2988 31.5209 19.8707L31.521 19.8705H31.5211Z",
    fill: "#F7931A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.056 13.7204C23.3745 11.5911 21.7532 10.4466 19.5363 9.68305L20.2555 6.79879L18.4996 6.36131L17.7994 9.16962C17.3378 9.0545 16.8638 8.94603 16.3926 8.8385L17.0978 6.01165L15.3429 5.57416L14.6234 8.45748C14.2414 8.37051 13.8662 8.28456 13.5021 8.194L13.5042 8.18493L11.0827 7.58031L10.6156 9.45555C10.6156 9.45555 11.9184 9.75414 11.8909 9.77252C12.602 9.94997 12.7305 10.4206 12.7092 10.7937L11.89 14.0795C11.9389 14.0919 12.0024 14.1099 12.0725 14.1381C12.0139 14.1235 11.9516 14.1077 11.8869 14.0922L10.7386 18.6952C10.6517 18.9112 10.4312 19.2354 9.93404 19.1123C9.95164 19.1378 8.6578 18.7938 8.6578 18.7938L7.78601 20.8036L10.0711 21.3731C10.4962 21.4797 10.9127 21.5912 11.323 21.6961L10.5964 24.6135L12.3503 25.0509L13.0698 22.1646C13.549 22.2946 14.014 22.4146 14.4692 22.5277L13.752 25.4005L15.5081 25.8379L16.2346 22.9261C19.2288 23.4927 21.4803 23.2642 22.4279 20.5563C23.1915 18.376 22.3899 17.1185 20.8146 16.2984C21.962 16.0338 22.8262 15.2793 23.0566 13.7206L23.0561 13.7202L23.056 13.7204ZM19.0441 19.3455C18.5014 21.5257 14.8302 20.3471 13.6399 20.0516L14.6041 16.1866C15.7943 16.4837 19.6112 17.0717 19.0442 19.3455H19.0441ZM19.5871 13.6888C19.0921 15.6719 16.0365 14.6644 15.0453 14.4174L15.9195 10.9121C16.9107 11.1591 20.1028 11.6202 19.5873 13.6888H19.5871Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_403_1315"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtc);
export default __webpack_public_path__ + "static/media/btc.29a8d2d676066b04aba5cdc7b7ea2fa9.svg";
export { ForwardRef as ReactComponent };